import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["nestedFields", "addProductsForm"];

  selectedItems = {};

  productsSelected({ detail: { selectedItems, value } }) {
    Object.values(selectedItems).forEach((product) => {
      this.addProduct(product, value);
    });
  }

  // Update the products modal with the list of products that
  // are already on this form
  addProductsFormTargetConnected() {
    const productsFormController =
      this.application.getControllerForElementAndIdentifier(
        this.addProductsFormTarget,
        "forms--pricing-list-products"
      );

    productsFormController.setExcludedProducts(this.selectedItems);
  }

  addProduct(product, value) {
    this.selectedItems[product.id] = product;
    const nestedFormController =
      this.application.getControllerForElementAndIdentifier(
        this.nestedFieldsTarget,
        "dynamic-nested-form"
      );
    nestedFormController.addNestedField((nestedFields) => {
      nestedFields.querySelector('input[name$="[product_id]"]').value =
        product.id;
      nestedFields.querySelector('input[name$="[price_value]"]').value = value;
      nestedFields.querySelector(".product-description").innerHTML =
        product.description;
    });
  }
}
